module.exports = __webpack_public_path__ + "img/cow_table_white.a9f01eec.svg";